import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlacklistElementsQuery,
  BlacklistElementsQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { blacklistElementFragment } from "src/graphql/anti-fraud/fragments/BlacklistElementFragment";
import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";
import { mapToBlacklistElement } from "src/mappers/blacklist.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getBlacklistElementsQuery = gql`
  query BlacklistElements(
    $blacklistCode: String!
    $includeDisabledElements: Boolean! = false
    $pagination: Pagination!
    $searchString: String
  ) {
    blacklistElements(
      input: {
        blacklistCode: $blacklistCode
        includeDisabledElements: $includeDisabledElements
        pagination: $pagination
        searchString: $searchString
      }
    ) {
      blacklistElements {
        ...BlacklistElement
      }
      pageInfo {
        totalCount
        offset
        limit
      }
    }
  }

  ${blacklistElementFragment}
` as TypedDocumentNode<BlacklistElementsQuery, BlacklistElementsQueryVariables>;

export const useGetBlacklistElementsQuery = (params: {
  blacklistCode?: string;
  includeDisabledElements?: boolean;
  pagination: { offset: number; limit: number };
  searchTerm?: string;
}) => {
  return useFetchQuery(getBlacklistElementsQuery, {
    toData: (data) => {
      return (
        data?.blacklistElements && {
          blacklistElements: data.blacklistElements.blacklistElements.map(mapToBlacklistElement),
          pageInfo: data.blacklistElements.pageInfo,
        }
      );
    },
    isEmpty: (data) => isEmpty(data?.blacklistElements?.blacklistElements),
    uiErrors: {
      fetchError: "FETCH-LIST-ELEMENTS-ERROR",
    },
    queryOptions: {
      fetchPolicy: "network-only",
      variables: {
        blacklistCode: params.blacklistCode ?? "",
        includeDisabledElements: params.includeDisabledElements ?? false,
        pagination: { offset: params.pagination.offset ?? 0, limit: params.pagination.limit ?? 50 },
        searchString: params.searchTerm || null,
      },
      skip: !params.blacklistCode,
    },
  });
};
